export default __webpack_public_path__ + "media/images/icons/plate-fb9eb87e33994829f08389b78c798dad.svg";